export interface EnvironmentInterface {
    status: EnvironmentStatus;
    uploadCenter: string;
    baseUrl: () => string;
    reduxDevTool: boolean;
    landingBaseUrl: string;
    feedbackLogUrl: string;
    brandName: string;
    googleAnalyticsId: string;
    hotJarId: number;
    metaDescription: string;
    taxPercent: number;
    linkMaxCount: number;
    android: string;
    prefix: string;
    country: string;
}

export enum EnvironmentStatus {
    production = "pr"
}

export enum zIndexs {
    contextMenu = "1000",
    previewModal2 = "998",
    otherModals = "997",
    previewModal = "996",
    sidebarModal = "995"
}
